export interface CheckoutRedirectPayload {
	checkoutUrl?: string | null;
	checkoutFormHtml?: string | null;
}

export function redirectToCheckout({
	checkoutUrl,
	checkoutFormHtml,
}: CheckoutRedirectPayload) {
	if (checkoutFormHtml) {
		const doc = document.open("text/html", "replace");
		doc.write(checkoutFormHtml);
		doc.close();
		return;
	}

	if (checkoutUrl) {
		window.location.href = checkoutUrl;
		return;
	}

	throw new Error("No checkout target returned by the server.");
}
